import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDCITYLINE_SOURCE_ID = 'browardCityLineSource';

const source = {
  id: BROWARDCITYLINE_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Broward_County_Cities_Boundary_Lines`,
};

export default source;
